module.exports = __webpack_public_path__ + "f5e2dda5acfc574a90dd0887f661b46b.png";